/**
 * Türkiye'nin 81 il merkezi koordinatları (il adı = il merkezi).
 * Haritada API'den konum adı gelmezse en yakın il adı kullanılır.
 * @type {Array<[number, number, string]>}
 */
export const TURKEY_PROVINCE_CENTERS = [
  [37.0, 35.3213, 'Adana'],
  [37.7648, 38.2786, 'Adıyaman'],
  [38.7638, 30.5403, 'Afyonkarahisar'],
  [39.7191, 43.0503, 'Ağrı'],
  [40.6499, 35.8353, 'Amasya'],
  [39.9334, 32.8597, 'Ankara'],
  [36.8969, 30.7133, 'Antalya'],
  [41.1828, 41.8183, 'Artvin'],
  [37.8444, 27.8458, 'Aydın'],
  [39.6484, 27.8826, 'Balıkesir'],
  [40.1426, 29.9793, 'Bilecik'],
  [38.8854, 40.4983, 'Bingöl'],
  [38.4006, 42.1095, 'Bitlis'],
  [40.7392, 31.6089, 'Bolu'],
  [37.7203, 30.2908, 'Burdur'],
  [40.1826, 29.0665, 'Bursa'],
  [40.1553, 26.4142, 'Çanakkale'],
  [40.6013, 33.6134, 'Çankırı'],
  [40.5506, 34.9556, 'Çorum'],
  [37.7765, 29.0864, 'Denizli'],
  [37.9144, 40.2306, 'Diyarbakır'],
  [41.6771, 26.5556, 'Edirne'],
  [38.6753, 39.221, 'Elazığ'],
  [39.75, 39.4918, 'Erzincan'],
  [39.9043, 41.2678, 'Erzurum'],
  [39.7767, 30.5206, 'Eskişehir'],
  [37.0662, 37.3833, 'Gaziantep'],
  [40.9128, 38.3895, 'Giresun'],
  [40.4608, 39.4786, 'Gümüşhane'],
  [37.5744, 43.7408, 'Hakkari'],
  [36.2025, 36.1603, 'Hatay'],
  [38.3687, 34.037, 'Aksaray'],
  [37.7648, 30.5566, 'Isparta'],
  [41.0082, 28.9784, 'İstanbul'],
  [38.4237, 27.1428, 'İzmir'],
  [37.5858, 36.9371, 'Kahramanmaraş'],
  [37.8812, 41.1351, 'Batman'],
  [40.6013, 43.0975, 'Kars'],
  [41.3887, 33.7827, 'Kastamonu'],
  [38.7312, 35.4787, 'Kayseri'],
  [39.8468, 33.5153, 'Kırıkkale'],
  [41.7333, 27.2253, 'Kırklareli'],
  [39.1425, 34.1709, 'Kırşehir'],
  [36.7184, 37.1212, 'Kilis'],
  [37.1759, 33.2287, 'Karaman'],
  [41.2061, 32.6204, 'Karabük'],
  [40.8533, 29.8815, 'Kocaeli'],
  [37.8715, 32.4846, 'Konya'],
  [39.4242, 29.9833, 'Kütahya'],
  [38.3552, 38.3095, 'Malatya'],
  [38.6191, 27.4289, 'Manisa'],
  [37.3212, 40.7245, 'Mardin'],
  [36.8121, 34.6415, 'Mersin'],
  [37.2153, 28.3636, 'Muğla'],
  [38.7432, 41.5065, 'Muş'],
  [38.6939, 34.6857, 'Nevşehir'],
  [37.9667, 34.6833, 'Niğde'],
  [40.9839, 37.8764, 'Ordu'],
  [37.0742, 36.2478, 'Osmaniye'],
  [40.9833, 27.5167, 'Tekirdağ'],
  [41.0201, 40.5234, 'Rize'],
  [40.7569, 30.3783, 'Sakarya'],
  [41.2928, 36.3313, 'Samsun'],
  [37.9333, 41.95, 'Siirt'],
  [42.0264, 35.155, 'Sinop'],
  [39.7477, 37.0179, 'Sivas'],
  [41.0015, 39.7178, 'Trabzon'],
  [39.1079, 39.5401, 'Tunceli'],
  [40.3167, 36.55, 'Tokat'],
  [37.1591, 38.7969, 'Şanlıurfa'],
  [38.6823, 29.4082, 'Uşak'],
  [38.4891, 43.4089, 'Van'],
  [40.65, 29.2667, 'Yalova'],
  [39.82, 34.8044, 'Yozgat'],
  [41.4564, 31.7987, 'Zonguldak'],
  [40.2552, 40.2249, 'Bayburt'],
  [37.5164, 42.4611, 'Şırnak'],
  [41.6344, 32.3375, 'Bartın'],
  [41.1105, 42.7022, 'Ardahan'],
  [39.9167, 44.0333, 'Iğdır'],
  [40.8438, 31.1565, 'Düzce'],
];

/** Alfabetik 81 il adı (şehir seçim listesi). */
export const TURKEY_PROVINCE_NAMES = TURKEY_PROVINCE_CENTERS.map(([, , name]) => name).sort((a, b) =>
  a.localeCompare(b, 'tr')
);

function haversineKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/** Koordinata en yakın il adını döndürür (81 il içinden). */
export function nearestProvinceName(lat, lng) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  let best = null;
  let bestKm = Infinity;
  for (const [clat, clng, name] of TURKEY_PROVINCE_CENTERS) {
    const km = haversineKm(lat, lng, clat, clng);
    if (km < bestKm) {
      bestKm = km;
      best = name;
    }
  }
  return best;
}
